import { proposalsMock } from "./mock";
import { IActionsheetRefProps } from "@repo/core/components/layout/Actionsheet/types";
import { useCallback, useRef, useState } from "react";
import { useNavigation } from "@repo/core/hooks/useNavigation";

import { getCreditTableProposalOptionsBySituationCode } from "./utils";
import { ProposalOptionsItemProps } from "@repo/core/screens/Proposals/screens/ProposalsSearch/components/ProposalOptionsSheet/ProposalOptionsItem/types";
import useFilterStore from "@repo/core/stores/proposals-filters";
import { ROUTES } from "@repo/core/routes";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { PROPOSAL_ACTIONS } from "@repo/core/constants/proposals";

export const CreditTableSearchController = () => {
  const { hasFilters } = useFilterStore();
  const { push } = useNavigation();

  const actionSheetRef = useRef<IActionsheetRefProps>(null);
  const [refreshing, setRefreshing] = useState(false);

  const [registerId, setRegisterId] = useState<string | null>(null);
  const [proposalOptions, setProposalOptions] = useState<
    Omit<ProposalOptionsItemProps, "onPress">[] | null
  >(null);

  const { isMobile } = useDimensions();

  const onRefresh = useCallback(() => {
    setRefreshing(true);
    setTimeout(() => {
      setRefreshing(false);
    }, 2000);
  }, []);

  const handleOpenOptions = (id: string, statusCode: string) => {
    setRegisterId(id);
    setProposalOptions(
      getCreditTableProposalOptionsBySituationCode(statusCode)
    );
    actionSheetRef.current?.open();
  };

  const handleOnPressOption = (action: string) => {
    switch (action) {
      case PROPOSAL_ACTIONS.SEE_PROPOSAL:
        push(ROUTES.proposalsViewInfo);
        actionSheetRef.current?.close();
        break;
      case PROPOSAL_ACTIONS.SEND_TO_CREDIT_TABLE:
        if (registerId) {
          push(ROUTES.sendCreditTable, {
            proposalId: registerId
          });
        }
        actionSheetRef.current?.close();
        break;
      default:
        console.log("action not found");
        break;
    }
  };

  const proposals = hasFilters ? [] : proposalsMock;

  return {
    proposals,
    actionSheetRef,
    handleOnPressOption,
    handleOpenOptions,
    proposalOptions,
    isMobile,
    registerId,
    onRefresh,
    refreshing
  };
};
